import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-navy-900 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yfcp5gvkz9lo">
        <div className="text-center" data-id="element-22" data-mp="1aogvsfbh86cb">
          <span className="metal-silver inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navy-950" data-id="element-23" data-mp="1apidv3qwtt3j">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgr75zy3yhv5" /> Incluidos sin costo extra
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1eqapg3n98a2z">
            Los {totalBonuses} Bonos Estratégicos
          </h2>
        </div>

        <div className="mt-10 grid gap-5" data-id="element-26" data-mp="qy3nmoyrfaw6">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-6 rounded-xl border border-silver-400/25 bg-navy-800 p-6 shadow-sm shadow-black/20 sm:p-8 md:grid-cols-[220px_1fr]" data-id="element-27" data-mp="29r1pv5nswurc" data-mpi={index}>
                <div className="flex items-start justify-between gap-4 md:flex-col md:justify-start" data-id="element-28" data-mp="1vrs8i2nuzuls">
                  <div className="flex items-center gap-3 md:flex-col md:items-start" data-id="element-29" data-mp="20qvfvtrbacwx">
                    <span className="metal-silver flex h-12 w-12 items-center justify-center rounded-md text-navy-950" data-id="element-30" data-mp="25q84aixtzs1m">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-31" data-mp="3c7d4x8skxd9j" />
                    </span>
                    <p className="text-xs font-extrabold uppercase tracking-[.16em] text-silver-300" data-id="element-32" data-mp="3h4vbwtn1diew">Bono {bonus.number}</p>
                  </div>
                  <p className="text-right text-xs font-bold text-silver-300 md:text-left" data-id="element-33" data-mp="1h5i1szvieen1">
                    <span className="block line-through" data-id="element-34" data-mp="1c42hja15oc5p">Valor real: {bonus.value}</span>
                    <span className="metal-silver mt-2 inline-block rounded-md px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navy-950" data-id="element-35" data-mp="1q3jyx4c4gn51">
                      Gratis
                    </span>
                  </p>
                </div>

                <div className="flex flex-col" data-id="element-36" data-mp="teckeg9x7eam">
                  <h3 className="text-xl font-extrabold leading-tight text-white" data-id="element-37" data-mp="tfnnsezgek17">{bonus.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-silver-200" data-id="element-38" data-mp="176irlcv3iaxx">{bonus.description}</p>

                  {bonus.listLabel && <p className="mt-4 text-sm font-semibold text-silver-100" data-id="element-39" data-mp="eoesbp8ve4g5">{bonus.listLabel}</p>}

                  {bonus.items && <ul className="mt-4 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-40" data-mp="an32bim33h7f">
                      {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-silver-100" data-id="element-41" data-mp="5a4olgmd66q6">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver-300" aria-hidden="true" data-id="element-42" data-mp="3mquuueqh6htq" />
                          {item}
                        </li>)}
                    </ul>}

                  {bonus.note && <p className="mt-4 text-sm italic leading-relaxed text-silver-300" data-id="element-43" data-mp="jafd4d07b986">{bonus.note}</p>}

                  {bonus.benefit && <p className="mt-5 rounded-lg border-l-4 border-silver-300 bg-navy-950 px-4 py-3 text-sm font-semibold text-white" data-id="element-44" data-mp="9byk7ahpckjh">
                      {bonus.benefit}
                    </p>}
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border-2 border-silver-300 bg-navy-950 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-45" data-mp="2z0s2rymk9bv4">
          <div data-id="element-46" data-mp="3f9zqyw6zotwt">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-silver-300" data-id="element-47" data-mp="3ahq0nf1ypru0">
              Valor total de los {totalBonuses} bonos
            </p>
            <p className="mt-1 font-serif text-2xl font-extrabold tracking-tight text-white line-through decoration-red-400 decoration-2" data-id="element-48" data-mp="35g92vserylhn">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-49" data-mp="1zk5avx66m44">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-silver-300" data-id="element-50" data-mp="3t7ekod49znul">Tu precio hoy</p>
            <p className="mt-1 inline-flex items-center gap-2 font-serif text-3xl font-extrabold tracking-tight text-silver-100" data-id="element-51" data-mp="3o81t5f2glslo">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-52" data-mp="3j9i8rj3ikovf" /> <span className="metal-text" data-id="element-53" data-mp="2cu7jpgy5djex">GRATIS</span>
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-silver-300" data-id="element-54" data-mp="27u3e4lys293h">
          Solo incluidos en esta oferta.
        </p>
      </div>
    </section>;
}